module.exports = __webpack_public_path__ + "static/media/400130_01.67f63417.png";